import React from 'react';
import useSearchParams from '../../../useSearchParams';
import Header from '../Header';
import Footer from './Footer';

const TrackedAtFilter = () => {
  const {query, setQuery} = useSearchParams();

  const onChangeFrom = (e: React.ChangeEvent<HTMLInputElement>) =>
    setQuery({...query, trackedAtFrom: e.target.value});

  const onChangeTo = (e: React.ChangeEvent<HTMLInputElement>) =>
    setQuery({...query, trackedAtTo: e.target.value});

  return (
    <>
      <Header title="最新Webサイト訪問期間" />
      <div className="p-6 bg-c-bg flex-1 flex flex-col gap-4 rounded-b overflow-y-scroll">
        <div className="bg-white p-6 rounded flex flex-col gap-2">
          <div className="flex items-center gap-4">
            <input
              type="date"
              value={query.trackedAtFrom}
              onChange={onChangeFrom}
              className="form-input p-2 leading-none text-sm"
            />
            <span>~</span>
            <input
              type="date"
              value={query.trackedAtTo}
              onChange={onChangeTo}
              className="form-input p-2 leading-none text-sm"
            />
          </div>
        </div>
      </div>
      <Footer
        onClear={() => setQuery({...query, trackedAtFrom: '', trackedAtTo: ''})}
      />
    </>
  );
};

export default TrackedAtFilter;
